import type { InputHTMLAttributes } from 'react';
import { formatAsYouType } from '@dsr/shared-types';

// Phone text input that formats US / international numbers as the user types
// (libphonenumber-js AsYouType, US default region). The value it holds and
// emits is the formatted display string ("(555) 123-4567" / "+44 20 7946 0958");
// the API normalizes to canonical E.164 on submit. Seed existing values with
// formatPhoneDisplay() so they render formatted on first paint.
type PhoneInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'type'
> & {
  value: string;
  onChange: (next: string) => void;
};

export function PhoneInput({
  value,
  onChange,
  className = 'form-input',
  ...rest
}: PhoneInputProps): JSX.Element {
  return (
    <input
      {...rest}
      type="tel"
      inputMode="tel"
      className={className}
      value={value}
      onChange={(e) => onChange(formatAsYouType(e.target.value))}
    />
  );
}
